import { React } from "react";
import classes from './Table.module.scss'

//MUI Imports
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function TableData({ tableData, schema }) {

    const results = Object.values(tableData);
    const totalQuestionCount = results.reduce((total, currentValue) => total = total + currentValue.questions.length,0);

    let totals = [];
    let lables =[];
    
    let riskMeta = schema.entryOptions.screen.assessment.riskOptions.order;
    let riskOptions = schema.entryOptions.screen.assessment.riskOptions.options;


    riskMeta.forEach(key =>{
        totals.push({
            total: results.reduce((total, currentValue) => total = total + currentValue.choiceCounts[key].count,0),
            color: riskOptions[key].chartColour
        })
        lables.push({
            lable: riskOptions[key].label,
            color: riskOptions[key].chartColour
        })

    })

    return (
        <div> 
            <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell className={`${classes.Table__impact_text}`}><strong>Impact Lever</strong></TableCell>
                        {lables.map((lable, index) => {
                            return(
                                <TableCell key={index}
                                    sx={{
                                        color: lable.color
                                    }}
                                ><strong>{lable.lable}</strong></TableCell>
                            ) 
                        })}
                        <TableCell  className={`${classes.Table__question_text}`}><strong>Total<br/>Questions</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {results.map((item, index) => {
                    return(
                        <TableRow key={index}>
                            <TableCell className={`${classes.Table__impact_text}`}>{item.label}</TableCell>
                            {riskMeta.map((key, index) => {
                                let color = riskOptions[key].chartColour;
                                return(
                                    <TableCell sx={{
                                        color: color
                                    }}
                                    key={index}>{item.choiceCounts[key].count}</TableCell>
                                ) 
                            })}
                            <TableCell className={`${classes.Table__question_text}`}>{item.questions.length}</TableCell>
                        </TableRow>
                    ) 
                })}
                <TableRow>
                    <TableCell className={`${classes.Table__impact_text}`}>Sum</TableCell>
                    {totals.map((total, index) => {
                        return(
                            <TableCell 
                            sx={{
                                color: total.color
                            }}
                            key={index}>{total.total}</TableCell>
                        ) 
                    })}
                    <TableCell className={`${classes.Table__question_text}`}>{totalQuestionCount}</TableCell>
                </TableRow>
                </TableBody>
            </Table>
            </TableContainer>
        </div>
    );

}
export default TableData